import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function getSessionId() {
  let sid = localStorage.getItem("ok_session_id");
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem("ok_session_id", sid);
  }
  return sid;
}

// Records every visit (path change) to the backend for B2B analytics.
export default function VisitTracker() {
  const location = useLocation();

  useEffect(() => {
    const sid = getSessionId();
    api
      .post("/visits", {
        path: location.pathname,
        referrer: document.referrer || null,
        session_id: sid,
      })
      .catch(() => {});
  }, [location.pathname]);

  return null;
}
